import React, { useEffect, useState } from 'react';
import { Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

const MenuTap = ({items, idActive, type}) => {
    const history = useHistory();
    const [customActiveTab, setcustomActiveTab] = useState(idActive);
    const [itemData, setItemData] = useState([]);
    const toggleCustom = (tabId, tabLink) => {
        history.push(tabLink);
        if (customActiveTab !== tabId) {
            setcustomActiveTab(tabId);
        }
    };

    useEffect(() => {
        if(type === "company-structure"){
            setItemData([
                {
                    id: "1",
                    name: "Business unit",
                    link: "/business-unit"
                },
                {
                    id: "2",
                    name: "Department",
                    link: "/department"
                },
                {
                    id: "3",
                    name: "Sub department",
                    link: "/sub-department"
                },
                {
                    id: "4",
                    name: "Division",
                    link: "/division"
                },
                {
                    id: "5",
                    name: "Sub division",
                    link: "/sub-division"
                },
                {
                    id: "6",
                    name: "Section",
                    link: "/section"
                },
                {
                    id: "7",
                    name: "Sub section",
                    link: "/sub-section"
                }
            ]);
        }else if(type === "education"){
            setItemData([
                {
                    id: "1",
                    name: "Level Education",
                    link: "/level-education"
                },
                {
                    id: "2",
                    name: "Institution",
                    link: "/institution"
                }
            ]);
        }else if(type === "position"){
            setItemData([
                {
                    id: "1",
                    name: "Position structure",
                    link: "/position"
                },
                {
                    id: "2",
                    name: "Level position",
                    link: "/level-position"
                }
            ]);
        }
    }, [type, setItemData]);

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <Nav tabs className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3">
                        {itemData.map((item, key) => (
                            <NavItem key={item.id}>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classNames({
                                        active: customActiveTab === item.id,
                                    })}
                                    onClick={() => {
                                        toggleCustom(item.id, item.link);
                                    }}
                                    // href={item.link}
                                >
                                    {item.name}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </Col>
            </Row>
        </React.Fragment>
    )
};

export default MenuTap;